export type SortKey =
  | 'sku' | 'name' | 'supplier' | 'current_stock' | 'lead_time' | 'monthly_avg'
  | 'daily_avg' | 'coverage_months' | 'coverage_days' | 'reorder_point'
  | 'gap_to_buy' | 'last_sale_at' | 'days_without_sale' | 'cost'
  | 'purchase_suggestion' | 'filial_suggestion' | 'total_suggestion'
  | 'approved_qty' | 'priority' | 'kanban_status'
  | 'order_number' | 'order_date' | 'order_status'

export interface ColumnDef {
  key: SortKey
  label: string
  numeric?: boolean
  /** Só aparece quando a empresa ativa é matriz com filiais vinculadas. */
  filialOnly?: boolean
  /** Quando true, não pode ser ocultada pelo menu "Colunas". */
  alwaysVisible?: boolean
}

// Âncoras de leitura (alwaysVisible:true) — SKU e Produto não podem ser ocultadas.
export const COLUMNS: ColumnDef[] = [
  { key: 'sku',                 label: 'Código', alwaysVisible: true },
  { key: 'name',                label: 'Produto', alwaysVisible: true },
  { key: 'supplier',            label: 'Fornecedor' },
  { key: 'current_stock',       label: 'Estoque Atual',         numeric: true },
  { key: 'lead_time',           label: 'Lead Time',             numeric: true },
  { key: 'monthly_avg',         label: 'Média Mensal',          numeric: true },
  { key: 'daily_avg',           label: 'Média Diária',          numeric: true },
  { key: 'coverage_months',     label: 'Cobertura (meses)',     numeric: true },
  { key: 'coverage_days',       label: 'Dias de Cobertura',     numeric: true },
  { key: 'reorder_point',       label: 'Ponto de Ressuprimento',numeric: true },
  { key: 'gap_to_buy',          label: 'Gap p/ Compra',         numeric: true },
  { key: 'last_sale_at',        label: 'Última Venda' },
  { key: 'days_without_sale',   label: 'Dias s/ Vender',        numeric: true },
  { key: 'cost',                label: 'Custo',                 numeric: true },
  { key: 'purchase_suggestion', label: 'Sugestão de Compra',    numeric: true },
  { key: 'filial_suggestion',   label: 'Necessidade Filial',    numeric: true, filialOnly: true },
  { key: 'total_suggestion',    label: 'Sugestão Total',        numeric: true, filialOnly: true },
  { key: 'approved_qty',        label: 'Quantidade do Pedido',  numeric: true },
  { key: 'priority',            label: 'Prioridade' },
  { key: 'kanban_status',       label: 'Status Kanban' },
  { key: 'order_number',        label: 'Nº Pedido' },
  { key: 'order_date',          label: 'Data Pedido' },
  { key: 'order_status',        label: 'Status Pedido' },
]
